import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { ShopperSocialGroupJoinScanPage } from './shopper-social-group-join-scan';

@NgModule({
  declarations: [
    ShopperSocialGroupJoinScanPage,
  ],
  imports: [
    IonicPageModule.forChild(ShopperSocialGroupJoinScanPage),
    TranslateModule.forChild()
  ],
})
export class ShopperSocialGroupJoinScanPageModule {}



// WEBPACK FOOTER //
// ./src/pages/shopper-social-group-join-scan/shopper-social-group-join-scan.module.ts